export default __webpack_public_path__ + "static/media/contract.d987ed42.jpg";